import { WorklistValues } from "features/WorklistTools/shared/interfaces";
import { isStringifiedInteger } from "features/WorklistTools/shared/WorklistHelpers";
import { useAppReduxSelector } from "hooks/reduxHooks";
import { TextEditor } from "react-data-grid";
import { useDispatch } from "react-redux";
import { Alert, AlertType } from "shared-components/toast";
import { CellNumberUpdateType } from "../../PoolingNormalizationToolHelpers";
import { PoolingNormalizationToolActions } from "../../state";
import { WellMapping } from "../WellMapping";
import { WellMappingTableHeader } from "../WellMappingTableHeader";

export const Int1ToInt3WellsMapping = () => {
  const worklistValues = useAppReduxSelector(
    (state) =>
      state.WorklistTools.PoolingNormalizationTool.present.worklistValues
  );
  const dispatch = useDispatch();
  const columns = [
    {
      key: "sourcePlateIndex",
      name: "Source Plate",
      formatter(props: any) {
        return <>{props.row.sourcePlateIndex + 1 ?? ""}</>;
      },
      resizable: true,
    },
    { key: "sourceWellId", name: "Source Pos", resizable: true },
    {
      key: "destPlateIndex",
      name: "Dest Plate",
      formatter(props: any) {
        return <>{props.row.destPlateIndex + 1}</>;
      },
      resizable: true,
    },
    { key: "destWellId", name: "Dest Pos", resizable: true },
    {
      key: "transferVol",
      name: "Cell Number",
      resizable: true,
      editor: TextEditor,
      formatter({ row }: any) {
        const value = row.transferVol;
        const parsed = parseInt(value, 10);
        return <>{!isNaN(parsed) ? parsed.toLocaleString("en-US") : value}</>;
      },
    },
  ];
  const handleApplyCellNumber = (
    option: string | number,
    cellNumber: number | undefined
  ) => {
    switch (option) {
      case "Apply to All":
        dispatch(
          PoolingNormalizationToolActions.UPDATE_INT1_TO_INT3_CELL_NUMBERS({
            updateType: CellNumberUpdateType.ALL,
            transferVol: cellNumber,
          })
        );
        break;
      case "Apply to Empty":
        dispatch(
          PoolingNormalizationToolActions.UPDATE_INT1_TO_INT3_CELL_NUMBERS({
            updateType: CellNumberUpdateType.EMPTY,
            transferVol: cellNumber,
          })
        );
        break;
    }
  };
  const setSingleCellNumber = (rows: unknown[]) => {
    const typedRows = rows as WorklistValues[];

    for (const row of typedRows) {
      if (
        row.transferVol !== "" &&
        row.transferVol &&
        !isStringifiedInteger(row.transferVol)
      ) {
        return Alert({
          type: AlertType.ERROR,
          message: "Please enter a valid whole number",
        });
      }
    }
    dispatch(
      PoolingNormalizationToolActions.UPDATE_INT1_TO_INT3_CELL_NUMBERS({
        updateType: CellNumberUpdateType.INDIVIDUAL,
        rows,
      })
    );
  };
  return (
    <WellMapping
      setSingleCellNumber={setSingleCellNumber}
      columns={columns}
      worklistValues={worklistValues.int1ToInt3}
      tableHeader={
        <WellMappingTableHeader handleApplyCellNumber={handleApplyCellNumber} />
      }
    />
  );
};
